module.exports = __webpack_public_path__ + "static/img/dy1-3.f6046e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/dy1-3.png
// module id = 939
// module chunks = 0